import React, { Component } from 'react';
import { Grid } from '@mui/material';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { withStyles } from '@mui/styles';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { styled } from '@mui/material';
import { Link } from 'react-router-dom';
import Skeleton from '@mui/material/Skeleton';
import { send_request } from '../../utils/Request';

const LoadingSkeleton = ({ width, marginBottom = 0, style }) => (
  <Skeleton animation="wave" height={24} width={width} style={{ marginBottom, ...style }} />
);

const NewTabIcon = styled(OpenInNewIcon)({
  height: '14px',
  width: 'auto',
  marginRight: 4,
});

const StyledSpan = styled('span')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  fontSize: '0.9em',
  marginTop: 16,
  color: theme.palette.text.primary,
  '&:hover': {
    cursor: 'pointer',
    filter: 'brightness(0.9)',
  },
}));

const ErrorMessage = styled('div')({
  color: 'red',
  marginTop: '8px',
  fontSize: '0.8rem',
});

const styles = theme => ({
  autocomplete: {
    '&> div > div > input': {
      height: 6,
    },
  },
});

class SelectProject extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      refreshLoading: false,
      selectOpen: false,
      databaseName: '',
      loadingDatabaseList: false,
      errorMessage: '',
    };
  }

  handleGetData = targetDatabaseId => {
    this.props.setIsLoading(true);
    this.props.updateTargetProject(targetDatabaseId);

    let currDatabase = this.props.databaseList.find(dB => dB.databaseId === targetDatabaseId);
    if (!currDatabase) return;
    this.setState({ databaseName: currDatabase.name });
  };

  componentDidMount() {
    let targetId = this.props.targetDatabaseId;

    let currDatabase = this.props.databaseList.find(dB => dB.databaseId === targetId);
    if (!currDatabase) this.setState({ targetDatabaseId: targetId });
    else this.setState({ targetDatabaseId: targetId, databaseName: currDatabase.name });
  }

  setDatabaseId = value => {
    this.props.setTargetDatabaseId(value);
  };

  refreshDatabaseList = async () => {
    this.setState({ loadingDatabaseList: true, errorMessage: '' });

    try {
      const response = await send_request(`database/get_databases`, '', {}, 'GET');
      if (response?.data) {
        if (this.props.updateDatabaseList) {
          this.props.updateDatabaseList(response.data);
        }

        if (this.props.targetDatabaseId) {
          const currDatabase = response.data.find(
            dB => dB.databaseId === this.props.targetDatabaseId
          );
          if (currDatabase) {
            this.setState({ databaseName: currDatabase.name });
          } else {
            const selectedDatabase = this.state.databaseName || 'Table';
            this.setState({
              databaseName: '',
              errorMessage: `${selectedDatabase} does not exist anymore`,
            });
            this.props.setTargetDatabaseId(null);
          }
        }
      }
    } catch (error) {
      console.error('Error refreshing database list:', error);
    } finally {
      this.setState({ loadingDatabaseList: false });
    }
  };

  handleDropdownOpen = () => {
    this.setState({ selectOpen: true });
    this.refreshDatabaseList();
  };

  handleDropdownClose = () => {
    this.setState({ selectOpen: false });
  };

  render() {
    const { component, isLoading, classes } = this.props;
    const { loadingDatabaseList, errorMessage } = this.state;
    const db = this.props.databaseList.filter(db => db.databaseId === this.props.targetDatabaseId);

    const isADatabaseSelected = db && db.length !== 0 && db[0];
    return (
      <Grid container>
        <Grid item xs={12}>
          Select table
        </Grid>
        <Grid item xs={12}>
          <Grid container display={'flex'} alignItems={'center'} marginTop={1}>
            <Grid item xs={5} marginRight={2}>
              <Autocomplete
                key={this.props.targetDatabaseId || ''}
                freeSolo
                options={this.props.databaseList}
                getOptionLabel={option => (option.name ? option.name : option.projectId)}
                renderInput={params => (
                  <TextField {...params} variant="outlined" placeholder="Select table" />
                )}
                renderOption={(props, option) => (
                  <li {...props} key={option.projectId}>
                    {option.name ? option.name : option.projectId}
                  </li>
                )}
                onChange={(event, newValue) => {
                  if (!newValue) {
                    this.setDatabaseId(null);
                    return;
                  }
                  this.setDatabaseId(newValue.databaseId);
                }}
                onOpen={this.handleDropdownOpen}
                onClose={this.handleDropdownClose}
                value={isADatabaseSelected ? db[0] : null}
                className={classes.autocomplete}
                loading={loadingDatabaseList}
                loadingText={
                  <div style={{ padding: '8px' }}>
                    <LoadingSkeleton width="80%" marginBottom={6} />
                    <LoadingSkeleton width="60%" marginBottom={6} />
                    <LoadingSkeleton width="70%" />
                  </div>
                }
              />
            </Grid>
            <Grid item>
              <Button
                variant={'contained'}
                color={'primary'}
                onClick={() => {
                  this.handleGetData(this.props.targetDatabaseId);
                }}
                style={{ marginRight: 16 }}
                disabled={isLoading}
              >
                {component === 'create_database_record' ? 'Get Columns' : 'Get Data'}
                {isLoading && <CircularProgress size={24} className="buttonProgress" />}
              </Button>
            </Grid>
          </Grid>
          <Grid item>{errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}</Grid>
        </Grid>
        {this.state.databaseName && (
          <Grid item xs={12}>
            <Link
              to={`/databases/database_management/${this.props.targetDatabaseId}`}
              target="_blank"
              style={{ textDecoration: 'none' }}
            >
              <StyledSpan>
                <NewTabIcon />
                Open {this.state.databaseName} in a new tab
              </StyledSpan>
            </Link>
          </Grid>
        )}
      </Grid>
    );
  }
}

export default withStyles(styles)(SelectProject);
